import { EvmPriceServiceConnection } from '@pythnetwork/pyth-evm-js';
import { decodeAbiParameters, encodeAbiParameters } from 'viem';
export class PythAdapter {
    constructor(endpoint) {
        this.connection = new EvmPriceServiceConnection(endpoint);
    }
    getOracleId() {
        return 'PYTH';
    }
    async fetchOffchainData(data, extraPriceIds = []) {
        const [updateType] = decodeAbiParameters([{ name: 'updateType', type: 'uint8' }], data);
        if (updateType === 1) {
            const [updateType, stalenessOrTime, priceIds] = decodeAbiParameters([
                { name: 'updateType', type: 'uint8' },
                { name: 'stalenessTolerance', type: 'uint64' },
                { name: 'priceIds', type: 'bytes32[]' },
            ], data);
            const allIds = [...new Set([...priceIds, ...extraPriceIds])];
            const stalenessTolerance = stalenessOrTime;
            let updateData = (await this.connection.getPriceFeedsUpdateData(allIds));
            return {
                data: encodePriceUpdateData(updateData, allIds, BigInt(stalenessTolerance), updateType),
                ids: allIds,
            };
        }
        else if (updateType === 2) {
            const [updateType, requestedTime, priceId] = decodeAbiParameters([
                { name: 'updateType', type: 'uint8' },
                { name: 'requestedTime', type: 'uint64' },
                { name: 'priceIds', type: 'bytes32' },
            ], data);
            const allIds = [...new Set([priceId, ...extraPriceIds])];
            let updateData = [];
            for (const extraId of allIds) {
                const [priceFeedUpdateVaa] = await this.connection.getVaa(extraId, Number(requestedTime.toString()));
                const priceFeedUpdate = '0x' + Buffer.from(priceFeedUpdateVaa, 'base64').toString('hex');
                updateData.push(priceFeedUpdate);
            }
            return {
                data: encodePriceUpdateData(updateData, [priceId], requestedTime, updateType),
                ids: allIds,
            };
        }
        else {
            throw new Error(`update type ${updateType} not supported`);
        }
    }
    async getUpdateDataAtTimestamp(priceIds, timestamp) {
        const result = await Promise.all(priceIds.map((id) => this.connection.getVaa(id, timestamp)));
        return result.map((res) => `0x${Buffer.from(res[0], 'base64').toString('hex')}`);
    }
}
export const encodePriceUpdateData = (updateData, ids, timestampOrTolerance, updateType) => {
    if (updateType === 2) {
        return encodeAbiParameters([
            { type: 'uint8', name: 'updateType' },
            { type: 'uint64', name: 'timestamp' },
            { type: 'bytes32[]', name: 'priceIds' },
            { type: 'bytes[]', name: 'updateData' },
        ], [updateType, timestampOrTolerance, ids, updateData]);
    }
    else {
        return encodeAbiParameters([
            { type: 'uint8', name: 'updateType' },
            { type: 'uint64', name: 'stalenessTolerance' },
            { type: 'bytes32[]', name: 'priceIds' },
            { type: 'bytes[]', name: 'updateData' },
        ], [updateType, timestampOrTolerance, ids, updateData]);
    }
};
